"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INDEX = exports.CLEANUP = exports.BOARD = void 0;
var BOARD = 'board';
exports.BOARD = BOARD;
var CLEANUP = 'cleanup';
exports.CLEANUP = CLEANUP;
var INDEX = 'index';
exports.INDEX = INDEX;